import { GPXFeature } from '@rsos/gainsight';
import { AccordionContainer } from '../TF911.styles';
import TF911StartChatMessages from '../TF911StartChatMessages';
import {
  ChatAccordion,
  OFFSET_HEIGHT,
  StartChatContainer,
  StartChatButton,
  ChatAccordionHeaderContainer,
} from './TF911StartChatAccordion.styles';

interface TF911StartChatBaseProps {
  gpxFeature: GPXFeature;
  handleDefaultStartClick: () => void;
  handleOnClickShowAccordion: () => void;
  isCreatingConversation: boolean;
  isForOverview: boolean;
  onStartConversation: (message?: string) => Promise<{ isSuccess: boolean }>;
  preconfiguredMessages: string[];
  showPreconfiguredMessages: boolean;
}

const TF911StartChatBase = ({
  gpxFeature,
  handleDefaultStartClick,
  handleOnClickShowAccordion,
  isCreatingConversation,
  isForOverview,
  onStartConversation,
  preconfiguredMessages,
  showPreconfiguredMessages,
}: TF911StartChatBaseProps) => {
  return (
    <StartChatContainer>
      <AccordionContainer showBorder={showPreconfiguredMessages} width="100%">
        <ChatAccordion
          btnDisabled={isCreatingConversation}
          callback={handleOnClickShowAccordion}
          content={
            <TF911StartChatMessages
              isCreatingConversation={isCreatingConversation}
              preconfiguredMessages={preconfiguredMessages}
              onSendMessageClick={onStartConversation}
              isUniteEventPaneEnabled={false}
              isForOverview={isForOverview}
              gpxFeature={gpxFeature}
            />
          }
          header={
            <ChatAccordionHeaderContainer borderRadius="0 0 5px 5px">
              <StartChatButton
                disabled={isCreatingConversation}
                isLoadingProp={isCreatingConversation}
                onClick={handleDefaultStartClick}
              >
                Start Chat
              </StartChatButton>
            </ChatAccordionHeaderContainer>
          }
          headerPadding={isForOverview ? '0 16px' : '0 12px'}
          isOpened={showPreconfiguredMessages}
          height={isForOverview ? '100%' : `calc(100% - ${OFFSET_HEIGHT}px)`}
        />
      </AccordionContainer>
    </StartChatContainer>
  );
};

export default TF911StartChatBase;
